import { render, staticRenderFns } from "./TextTrioOfImages.vue?vue&type=template&id=5ed393c6&scoped=true&"
import script from "./TextTrioOfImages.vue?vue&type=script&lang=js&"
export * from "./TextTrioOfImages.vue?vue&type=script&lang=js&"
import style0 from "./TextTrioOfImages.vue?vue&type=style&index=0&id=5ed393c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed393c6",
  null
  
)

export default component.exports